/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId.js.map